/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/return-await */

import type { IUser, NotificationSettings } from 'garden-common';
import type { AxiosError } from 'axios';


import { getAuth } from 'firebase/auth';
import { get } from 'svelte/store';
import { me } from '../../stores/user.store';

import {api} from './index';

import { firebaseMessagingToken } from '../../stores/firebase.store';

import { goto } from '$app/navigation';
import { browser } from '$app/environment';

import { isLoggedIn } from '../../stores/auth.store';


// Helper function to extract only basic user details
const getShortUserDetails = (user: any) => {
    const basicInfo = {
        _id: user._id,
        name: user.name,
        userName: user.userName,
        email: user.email,
        drafts: user.drafts,
        profileImage: user.profileImage,
        coverImage: user.coverImage
    };
    return basicInfo;
};

export type SignUpResponse = {
    isSuccess: boolean;
    message?: string;
    accessToken?: string;
    refreshToken?: string;
    user?: any;
    wallet?: string | null;
    errors: { msg: string; }[];
    gardenCode?: number;
};

export const signUp = async (
    username: string,
    email: string,
    password: string,
    name?: string,
    coverImage?: any,
    profileImage?: any
) => {
    const data = new FormData();
    console.log('signUp -> data', data);

    data.append(
        'details',
        JSON.stringify({
            name: name ?? username,
            username,
            email,
            password,
            coverImage: typeof coverImage === 'string' ? coverImage : null,
            profileImage: typeof profileImage === 'string' ? profileImage : null,
        })
    );
    if (profileImage) data.append('profileImage', profileImage);
    if (coverImage) data.append('coverImage', coverImage);

    return await api
        .post('/user/signup', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(
            res => {
                return res.data;
            },
            error => {
                return error.response.data as SignUpResponse;
            }
        );
};

export const firebaseSignUp = async (
    username: string,
    email: string,
    firebaseUid: string,
    token: string
) => {
    return await api
        .post(
            '/user/firebaseSignUp',
            {
                name: username,
                username,
                email,
                firebaseUid
            },
            {
                headers: {
                    'firebase-token': token
                }
            }
        )
        .then(
            res => {
                const data = res.data as SignUpResponse;
                return data.user as IUser<string>;
            },
            error => {
                const errorResp = error as AxiosError;
                throw errorResp.response.data;
            }
        );
};

export const login = async (
    email: string,
    password: string
): Promise<{
    accessToken: string;
    refreshToken: string;
    user: IUser<string>;
    wallet: any;
}> => {
    return await api
        .post('/user/login', {
            email,
            password
        })
        .then(
            res => {
                return res.data;
            },
            error => {
                error.response.data.error = true;
                return error.response.data;
            }
        );
};

export const getUserDetails = async (username: string) => {
    return await api
        .get(`/user/details/${username}`, {
            headers: {
                'cache-control': 'public, max-age=3600'
            }
        })
        .then(res => {
            return res.data.user;
        });
};

interface CheckAvailableResponse {
    isTaken: boolean;
    alternatives: string[];
    message: string;
    isSuccess: boolean;
}


export const checkAvailable = async (email: string, name: string, username: string): Promise<CheckAvailableResponse> => await api.post(
    `/v2/user/available/${username}`,
    { email, name }).then(
        res => res.data as unknown as CheckAvailableResponse,
        error => error?.response?.data as unknown as CheckAvailableResponse);




export const getMe = async (): Promise<IUser<string>> => {
    if (get(me)) return get(me);

    return await api
        .get(`/user/me`)
        .then(res => {
            me.set(res.data.me);
            isLoggedIn.set(true);
            return res.data.me;
        })
        .catch(error => {
            console.log(error);
            isLoggedIn.set(false);
            return null;
        });
};

export const userDetails = async (id: string, short = false): Promise<IUser<string>> => {
    try {
        const ret = await api
            .get(`/user/userDetails/${id}`, {
                headers: {
                    'cache-control': 'public, max-age=3600'
                }
            })
            .then(res => {
                const data = res.data || {};
                const returnedUserDetails = short
                    ? getShortUserDetails(data.user || data.users)
                    : data.user || data.users;
                return returnedUserDetails;
            });
        return ret;
    } catch (error) {
        return error.response;
    }
};

export const shareReward = async (id: string, user: string) => {
    return await api
        .post(`/user/share/reward/${id}`, {
            user
        })
        .then(res => {
            return res.data?.user;
        });
};

export const updateUser = async (
    update: {
        key: string;
        value: any;
    }[]
): Promise<any> => {
    return await api
        .post('/user/update/', {
            update
        })
        .then(
            res => {
                me.set(res.data.updatedUser);
                // No calls need it to be boolean
                // return updated user for hot replacing
                // edits instead of invalidating
                return res.data.updatedUser;
            },
            error => {
                throw error.response;
            }
        );
};

export const getBlockedUsers = async () => {
    return await api.get('/user/blockedUsers').then(res => {
        return res.data;
    });
};

export const blockedUser = async (id: string) => {
    return await api.get(`/user/block/${id}`).then(res => {
        return res.data;
    });
};

export const unblockedUser = async (id: string) => {
    return await api.get(`/user/unblock/${id}`).then(res => {
        return res.data;
    });
};

export const updateUserNotifications = async (update: NotificationSettings) => {
    return await api.put(`/user/update/notifications`, update).then(res => {
        return res.data;
    });
};

export const postUserChangedPassword = async (oldPassword: string, newPassword: string) => {
    return await api
        .post('/user/changePassword', {
            oldPassword,
            newPassword
        })
        .then(
            res => {
                return res.data;
            },
            error => {
                return error.response.data;
            }
        );
};

export const getTopDonors = async () => {
    return await api
        .get('/user/topDonors', {
            headers: {
                'cache-control': 'public, max-age=3600'
            }
        })
        .then(res => {
            return res.data.users;
        });
};

export const getUserFollowers = async () => {
    return await api.get('/user/followers').then(
        res => {
            return res.data.users;
        },
        error => {
            return error.response.data.message;
        }
    );
};

export const getUserFollowings = async () => {
    return await api
        .get('/user/followings', {
            headers: {
                'cache-control': 'public, max-age=3600'
            }
        })
        .then(
            res => {
                return res.data.users;
            },
            error => {
                return error.response.data.message;
            }
        );
};


/**
 * Follows a user based on ID
 */
export const followUser = async (id: string) => {
    return await api.get(`/user/follow/${id}`).then(
        res => {
            return res.data.message;
        },
        error => {
            throw error.response.data.message;
        }
    );
};

/**
 * Unfollows a user based on ID
 */
export const unfollowUser = async (id: string) => {
    return await api.get(`/user/unfollow/${id}`).then(
        res => {
            return res.data.message;
        },
        error => {
            throw error.response.data.message;
        }
    );
};

export const getUserContributions = async (
    user: any,
    filters: any = {},
    sort: any = { createdAt: -1 },
    limit = 10,
    skip = 0
) => {
    const filter = {
        filters: {
            $or: [
                {
                    likes: user._id
                },
                {
                    _id: user.userComments.map(comment => comment.commentItem)
                }
            ],
            ...filters
        },
        sort
    };

    return await api.post(`/item/items/filter?limit=${limit}&skip=${skip}`, filter).then(res => {
        return res.data.items;
    });
};

export const sendEmailVerificationCode = async (email: string) => {
    return await api
        .post('/user/email/verify', {
            email
        })
        .then(res => res);
};

export const verifyEmailCode = async (email: string, code: string) => {
    return await api
        .post(`/user/email/verify/${code}`, {
            email
        })
        .then(
            res => {
                return res.data.message;
            },
            error => {
                return error.response.data.message;
            }
        );
};

export const sendPasswordRecoveryEmail = async (email: string) => {
    return await api.post('/user/recovery', {
        email
    });
};

export const resetPasswordThroughLink = async (userId: string, token: string, password: string) => {
    return await api
        .post(`/user/recovery/${userId}/${token}`, {
            password
        })
        .then(res => res.data);
};

export const saveFcmToken = async (token: string) => {
    if (!token) return;
    await getMe();
    // not directly returning the promise because
    // returned promises will not be caught in an async function try/catch
    const fcmSaveReturn = await api.post('/user/saveFcmToken', {
        fcmToken: token
    });
    return fcmSaveReturn;

};

export const removeFcmToken = async (token: string) => {
    try {
        return await api.post('/user/removeFcmToken', {
            fcmToken: token
        });
    } catch (error) {
        console.warn('FCM Token revoke error');
    }
};
export const logout = async () => {
    if (!browser || !get(me)) return;

    // unsibscribe notifications
    await goto('/login');

    await removeFcmToken(get(firebaseMessagingToken));

    // firebase signout
    const auth = getAuth();
    await auth.signOut();

    me.set(null);

    // 👉️ can use localStorage here

    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
};

export const deleteUser = async () => {
    return await api.delete('/user/');
};

export const getAllUsers = async (
    limit: number,
    filter: any,
    sort: any = { createdAt: -1 },
    skip = 0,
) => {
    return await api
        .post(`/user/users/filter?limit=${limit}&skip=${skip}`, {
            sort,
            filter
        })
        .then(res => {
            return res.data.users;
        });
};
